(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  (() => {
    class HeemanAnnouncement extends HTMLElement {
      connectedCallback() {
        this.key = this.dataset.dismissKey || '';
        this.button = this.querySelector('[data-announcement-dismiss]');

        /* Always visible in the theme editor, whatever the session says. */
        if (this.key && !this.designMode() && this.isDismissed()) {
          this.hidden = true;
        }

        if (!this.button || this.bound) return;
        this.bound = true;
        this.onDismiss = () => this.dismiss();
        this.button.addEventListener('click', this.onDismiss);
      }

      disconnectedCallback() {
        if (this.button && this.onDismiss) {
          this.button.removeEventListener('click', this.onDismiss);
        }
        this.bound = false;
      }

      designMode() {
        return Boolean(
          document.body && document.body.classList.contains('shopify-design-mode')
        );
      }

      isDismissed() {
        try {
          return window.sessionStorage.getItem(this.key) === '1';
        } catch (error) {
          return false;
        }
      }

      dismiss() {
        if (this.key) {
          try {
            window.sessionStorage.setItem(this.key, '1');
          } catch (error) {
            /* Private mode / quota: hide for this page view only. */
          }
        }
        this.hidden = true;
      }
    }

    if (!customElements.get('heeman-announcement')) {
      customElements.define('heeman-announcement', HeemanAnnouncement);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["article"]) return;
  try {
    
  /* <heeman-copy-link data-url data-success-message> wrapping one <button>.
     Copies the URL to the clipboard and announces via the global toast
     singleton (heeman:toast, 00 §5.3). Never renders the toast snippet.
     All strings arrive via data-* attributes — Liquid is not rendered here. */
  class HeemanCopyLink extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('button');
      if (!this.button) return;
      if (this.bound) return;
      this.bound = true;
      this.button.addEventListener('click', () => this.copy());
    }

    copy() {
      const url = this.dataset.url;
      if (!url) return;

      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(
          () => this.announce(),
          () => this.fallback(url)
        );
        return;
      }

      this.fallback(url);
    }

    announce() {
      const message = this.dataset.successMessage;
      if (!message) return;
      if (window.Heeman && typeof window.Heeman.dispatch === 'function') {
        window.Heeman.dispatch('heeman:toast', { message: message });
        return;
      }
      document.dispatchEvent(
        new CustomEvent('heeman:toast', { detail: { message: message }, bubbles: true })
      );
    }

    /* No clipboard access: surface the URL in a temporary read-only input and
       select it so the visitor can copy manually. No toast is fired. */
    fallback(url) {
      if (this.input) {
        this.input.select();
        return;
      }
      const input = document.createElement('input');
      input.type = 'text';
      input.className = 'article__share-fallback';
      input.readOnly = true;
      input.value = url;
      this.appendChild(input);
      this.input = input;
      input.select();
      try {
        document.execCommand('copy');
      } catch (error) {
        /* Manual copy only — the input stays selected for the visitor. */
      }
    }
  }

  if (!customElements.get('heeman-copy-link')) {
    customElements.define('heeman-copy-link', HeemanCopyLink);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  (() => {
    function dispatch(name, detail) {
      if (window.Heeman && typeof window.Heeman.dispatch === 'function') {
        window.Heeman.dispatch(name, detail);
        return;
      }
      document.dispatchEvent(new CustomEvent(name, { detail: detail, bubbles: true }));
    }

    class HeemanCartDrawer extends HTMLElement {
      connectedCallback() {
        if (!this.boundUpdated) {
          this.boundUpdated = this.handleUpdated.bind(this);
          this.boundChange = this.handleChange.bind(this);
          this.boundSelect = this.handleSelect.bind(this);
          this.boundDeselect = this.handleDeselect.bind(this);
          /* Element listener: survives content swaps and DOM moves. */
          this.addEventListener('change', this.boundChange);
        }

        document.addEventListener('heeman:cart:updated', this.boundUpdated);
        /* Theme editor only: selecting the section in the editor reveals it. */
        document.addEventListener('shopify:section:select', this.boundSelect);
        document.addEventListener('shopify:section:deselect', this.boundDeselect);
      }

      disconnectedCallback() {
        document.removeEventListener('heeman:cart:updated', this.boundUpdated);
        document.removeEventListener('shopify:section:select', this.boundSelect);
        document.removeEventListener('shopify:section:deselect', this.boundDeselect);
      }

      /* --- open/close is spec 02's <heeman-dialog>; we only delegate --- */
      dialogHost() {
        return this.querySelector('heeman-dialog');
      }

      handleSelect(event) {
        const host = this.dialogHost();
        if (!host || typeof host.open !== 'function') return;
        if (!event.target.contains(this)) return;
        host.open();
      }

      handleDeselect(event) {
        const host = this.dialogHost();
        if (!host || typeof host.close !== 'function') return;
        if (!event.target.contains(this)) return;
        host.close();
      }

      /* --- re-render from the server after any cart mutation ---------- */
      handleUpdated(event) {
        let cart = null;
        if (event.detail && event.detail.cart) cart = event.detail.cart;

        if (!window.Heeman || typeof window.Heeman.fetchSection !== 'function') return;

        const focusState = this.captureFocus();
        window.Heeman
          .fetchSection(this.dataset.sectionId || 'cart-drawer')
          .then((fragment) => {
            const next = fragment.querySelector('[data-cart-drawer-content]');
            const current = this.querySelector('[data-cart-drawer-content]');
            if (!next || !current) return;
            current.replaceWith(next);
            this.restoreFocus(focusState);
            this.announce(cart);
          })
          .catch(() => this.clearPending());
      }

      /* Re-render failed: keep the server DOM but drop the in-flight state. */
      clearPending() {
        this.querySelectorAll('.is-loading').forEach((element) => {
          element.classList.remove('is-loading');
          element.removeAttribute('aria-busy');
        });
        this.querySelectorAll('[data-cart-checkout]').forEach((button) => {
          button.removeAttribute('aria-disabled');
        });
      }

      announce(cart) {
        const node = this.querySelector('[data-cart-announce]');
        if (!node || !cart) return;
        const template = node.getAttribute('data-announce-template') || '';
        if (!template) return;
        let amount = '';
        if (window.Heeman && typeof window.Heeman.formatMoney === 'function') {
          amount = window.Heeman.formatMoney(cart.total_price);
        }
        node.textContent = template.replace('__amount__', amount);
      }

      /* --- focus continuity across the swap -------------------------- */
      captureFocus() {
        const active = document.activeElement;
        if (!active || !this.contains(active)) return null;
        const item = active.closest('heeman-cart-item');
        let role = null;
        if (active.closest('[data-cart-remove]')) {
          role = 'remove';
        } else if (active.closest('heeman-quantity')) {
          if (active.hasAttribute('data-minus')) {
            role = 'minus';
          } else if (active.hasAttribute('data-plus')) {
            role = 'plus';
          } else {
            role = 'input';
          }
        }
        let key = null;
        if (item) key = item.dataset.lineKey;
        return { key: key, role: role };
      }

      restoreFocus(state) {
        if (!state) return;
        let item = null;
        let target = null;
        if (state.key) {
          item = this.querySelector('heeman-cart-item[data-line-key="' + state.key + '"]');
        }
        if (item) {
          if (state.role === 'remove') target = item.querySelector('[data-cart-remove]');
          if (state.role === 'minus') target = item.querySelector('heeman-quantity [data-minus]');
          if (state.role === 'plus') target = item.querySelector('heeman-quantity [data-plus]');
          if (state.role === 'input') target = item.querySelector('input[name="updates[]"]');
          if (!target || target.disabled) target = item.querySelector('input[name="updates[]"]');
        }
        if (!target) target = this.querySelector('[data-cart-heading]');
        if (target) target.focus();
      }

      /* --- order note ------------------------------------------------ */
      handleChange(event) {
        const field = event.target;
        if (!field || !field.matches || !field.matches('[data-cart-note]')) return;

        fetch(this.dataset.updateUrl || '/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({ note: field.value })
        })
          .then((response) => {
            if (!response.ok) throw new Error('note');
          })
          .catch(() => {
            const message = this.dataset.errorText || '';
            if (message) dispatch('heeman:toast', { message: message });
          });
      }
    }

    if (!customElements.get('heeman-cart-drawer')) {
      customElements.define('heeman-cart-drawer', HeemanCartDrawer);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  (() => {
    function dispatch(name, detail) {
      if (window.Heeman && typeof window.Heeman.dispatch === 'function') {
        window.Heeman.dispatch(name, detail);
        return;
      }
      document.dispatchEvent(new CustomEvent(name, { detail: detail, bubbles: true }));
    }

    class HeemanCartPage extends HTMLElement {
      connectedCallback() {
        if (!this.boundUpdated) {
          this.boundUpdated = this.handleUpdated.bind(this);
          this.boundChange = this.handleChange.bind(this);
          /* Element listener: survives content swaps and DOM moves. */
          this.addEventListener('change', this.boundChange);
        }

        document.addEventListener('heeman:cart:updated', this.boundUpdated);
      }

      disconnectedCallback() {
        document.removeEventListener('heeman:cart:updated', this.boundUpdated);
      }

      /* Any mutation (this page, the drawer, a PDP add) re-renders this
         section from the server — the response is the single source of truth. */
      handleUpdated(event) {
        let cart = null;
        if (event.detail && event.detail.cart) cart = event.detail.cart;

        if (!window.Heeman || typeof window.Heeman.fetchSection !== 'function') return;
        const sectionId = this.dataset.sectionId;
        if (!sectionId) return;

        const focusState = this.captureFocus();
        window.Heeman
          .fetchSection(sectionId)
          .then((fragment) => {
            const next = fragment.querySelector('[data-cart-page-content]');
            const current = this.querySelector('[data-cart-page-content]');
            if (!next || !current) return;
            current.replaceWith(next);
            this.restoreFocus(focusState);
            this.announce(cart);
          })
          .catch(() => this.clearPending());
      }

      /* Re-render failed: keep the server DOM but drop the in-flight state. */
      clearPending() {
        this.querySelectorAll('.is-loading').forEach((element) => {
          element.classList.remove('is-loading');
          element.removeAttribute('aria-busy');
        });
        this.querySelectorAll('[data-cart-checkout]').forEach((button) => {
          button.removeAttribute('aria-disabled');
        });
      }

      announce(cart) {
        const node = this.querySelector('[data-cart-announce]');
        if (!node || !cart) return;
        const template = node.getAttribute('data-announce-template') || '';
        if (!template) return;
        let amount = '';
        if (window.Heeman && typeof window.Heeman.formatMoney === 'function') {
          amount = window.Heeman.formatMoney(cart.total_price);
        }
        node.textContent = template.replace('__amount__', amount);
      }

      captureFocus() {
        const active = document.activeElement;
        if (!active || !this.contains(active)) return null;
        const item = active.closest('heeman-cart-item');
        let role = null;
        if (active.closest('[data-cart-remove]')) {
          role = 'remove';
        } else if (active.closest('heeman-quantity')) {
          if (active.hasAttribute('data-minus')) {
            role = 'minus';
          } else if (active.hasAttribute('data-plus')) {
            role = 'plus';
          } else {
            role = 'input';
          }
        }
        let key = null;
        if (item) key = item.dataset.lineKey;
        return { key: key, role: role };
      }

      restoreFocus(state) {
        if (!state) return;
        let item = null;
        let target = null;
        if (state.key) {
          item = this.querySelector('heeman-cart-item[data-line-key="' + state.key + '"]');
        }
        if (item) {
          if (state.role === 'remove') target = item.querySelector('[data-cart-remove]');
          if (state.role === 'minus') target = item.querySelector('heeman-quantity [data-minus]');
          if (state.role === 'plus') target = item.querySelector('heeman-quantity [data-plus]');
          if (state.role === 'input') target = item.querySelector('input[name="updates[]"]');
          if (!target || target.disabled) target = item.querySelector('input[name="updates[]"]');
        }
        if (!target) target = this.querySelector('[data-cart-heading]');
        if (target) target.focus();
      }

      /* Order note — persisted without a re-render. */
      handleChange(event) {
        const field = event.target;
        if (!field || !field.matches || !field.matches('[data-cart-note]')) return;

        fetch(this.dataset.updateUrl || '/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({ note: field.value })
        })
          .then((response) => {
            if (!response.ok) throw new Error('note');
          })
          .catch(() => {
            const message = this.dataset.errorText || '';
            if (message) dispatch('heeman:toast', { message: message });
          });
      }
    }

    if (!customElements.get('heeman-cart-page')) {
      customElements.define('heeman-cart-page', HeemanCartPage);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  (() => {
    const DESKTOP = '(min-width: 990px)';
    const STORAGE_KEY = 'heeman:plp:columns';
    const DEBOUNCE_MS = 400;

    class HeemanFacets extends HTMLElement {
      connectedCallback() {
        this.sectionId = this.dataset.sectionId || '';
        this.requestId = 0;
        this.debounceTimer = null;
        this.media = window.matchMedia(DESKTOP);
        this.wasDesktop = null;

        this.onChange = this.handleChange.bind(this);
        this.onInput = this.handleInput.bind(this);
        this.onClick = this.handleClick.bind(this);
        this.onSubmit = this.handleSubmit.bind(this);
        this.onMedia = () => this.layout();
        this.onPopState = () => {
          this.render(window.location.pathname + window.location.search, false);
        };

        this.addEventListener('change', this.onChange);
        this.addEventListener('input', this.onInput);
        this.addEventListener('click', this.onClick);
        this.addEventListener('submit', this.onSubmit);
        window.addEventListener('popstate', this.onPopState);
        if (this.media.addEventListener) {
          this.media.addEventListener('change', this.onMedia);
        } else if (this.media.addListener) {
          this.media.addListener(this.onMedia);
        }

        this.wireDrawer();
        this.enhanceForm();
        this.layout();
        this.restoreDensity();
      }

      disconnectedCallback() {
        window.removeEventListener('popstate', this.onPopState);
        if (this.media && this.media.removeEventListener) {
          this.media.removeEventListener('change', this.onMedia);
        } else if (this.media && this.media.removeListener) {
          this.media.removeListener(this.onMedia);
        }
        window.clearTimeout(this.debounceTimer);
      }

      get form() {
        return this.querySelector('[data-facets-form]');
      }

      get dialogHost() {
        return this.querySelector('heeman-dialog');
      }

      /* ---------- Progressive-enhancement markers --------------------- */

      enhanceForm() {
        const form = this.form;
        if (form) form.classList.add('is-live');

        this.querySelectorAll('[data-facets-show-more]').forEach((button) => {
          const group = button.closest('.facets__group');
          if (!group) return;
          group.classList.add('is-collapsible');
          group.classList.remove('is-expanded');
          button.hidden = false;
          button.setAttribute('aria-expanded', 'false');
          if (button.dataset.labelMore) button.textContent = button.dataset.labelMore;
        });

        this.buildPresets();
      }

      buildPresets() {
        const format = window.Heeman && window.Heeman.formatMoney;
        if (typeof format !== 'function') return;

        this.querySelectorAll('[data-price-presets]').forEach((host) => {
          const rangeMax = parseInt(host.dataset.rangeMax || '0', 10);
          host.textContent = '';
          if (!rangeMax || rangeMax <= 0) return;

          /* Quartile bounds are whole currency units, because the price filter
             params (and the inputs) are in units, not cents. */
          const q1 = Math.max(1, Math.round(rangeMax / 400));
          const q2 = q1 * 2;
          const q3 = q1 * 3;
          const under = host.dataset.textUnder || '[amount]';
          const over = host.dataset.textOver || '[amount]';
          const bands = [
            { label: under.replace('[amount]', format(q1 * 100)), min: '', max: q1 },
            { label: format(q1 * 100) + ' – ' + format(q2 * 100), min: q1, max: q2 },
            { label: format(q2 * 100) + ' – ' + format(q3 * 100), min: q2, max: q3 },
            { label: over.replace('[amount]', format(q3 * 100)), min: q3, max: '' }
          ];

          bands.forEach((band) => {
            const chip = document.createElement('button');
            chip.type = 'button';
            chip.className = 'chip facets__preset';
            chip.dataset.pricePreset = '';
            chip.dataset.presetMin = String(band.min);
            chip.dataset.presetMax = String(band.max);
            chip.textContent = band.label;
            host.appendChild(chip);
          });
        });
      }

      /* ---------- Sidebar <-> drawer relocation ----------------------- */

      /* The dialog element survives every content swap, so this is wired once;
         the trigger is looked up lazily because the toolbar can be replaced. */
      wireDrawer() {
        const dialog = this.querySelector('[data-facets-dialog]');
        if (!dialog) return;
        dialog.addEventListener('close', () => {
          const trigger = this.querySelector('[data-dialog-open]');
          if (trigger) trigger.setAttribute('aria-expanded', 'false');
        });
      }

      layout() {
        const panel = this.querySelector('[data-facets-panel]');
        const desktop = this.media.matches;
        const changed = this.wasDesktop !== desktop;
        this.wasDesktop = desktop;

        if (panel) {
          const home = this.querySelector('[data-sidebar-home]');
          const slot = this.querySelector('[data-facets-slot]');
          const target = desktop ? home : slot;
          if (target && panel.parentElement !== target) target.appendChild(panel);
        }

        if (desktop && changed) this.closeDrawer();
        this.syncGroups(changed);
      }

      /* Filter groups start open; they are collapsed on mobile so the drawer
         opens on a scannable list. Server-rendered markup is always open, so
         this runs again after every re-render. */
      syncGroups(force) {
        const desktop = this.media.matches;
        if (!desktop || force) {
          this.querySelectorAll('[data-facets-group]').forEach((group) => {
            group.open = desktop;
          });
        }
      }

      closeDrawer() {
        const host = this.dialogHost;
        if (host && typeof host.close === 'function') host.close();
      }

      /* ---------- Grid density --------------------------------------- */

      restoreDensity() {
        let columns = this.dataset.columns || '4';
        try {
          const saved = window.localStorage.getItem(STORAGE_KEY);
          if (saved === '3' || saved === '4') columns = saved;
        } catch (error) {
          /* storage unavailable — session default */
        }
        this.applyDensity(columns, false);
      }

      applyDensity(columns, persist) {
        this.columns = columns;
        this.style.setProperty('--plp-columns', columns);
        this.querySelectorAll('[data-density]').forEach((button) => {
          button.setAttribute('aria-pressed', button.dataset.density === columns ? 'true' : 'false');
        });
        if (!persist) return;
        try {
          window.localStorage.setItem(STORAGE_KEY, columns);
        } catch (error) {
          /* storage unavailable — this page only */
        }
      }

      /* ---------- Events --------------------------------------------- */

      handleChange(event) {
        const target = event.target;
        if (!target) return;
        if (target.matches('[data-sort-select]')) {
          this.apply();
          return;
        }
        const form = this.form;
        if (!form || !form.contains(target)) return;
        if (target.type === 'number') {
          this.applyDebounced();
          return;
        }
        this.apply();
      }

      handleInput(event) {
        const target = event.target;
        if (!target || target.type !== 'number') return;
        const form = this.form;
        if (!form || !form.contains(target)) return;
        this.applyDebounced();
      }

      handleClick(event) {
        const target = event.target;
        if (!target || !target.closest) return;

        const opener = target.closest('[data-dialog-open]');
        if (opener) {
          opener.setAttribute('aria-expanded', 'true');
          return;
        }

        const showMore = target.closest('[data-facets-show-more]');
        if (showMore) {
          const group = showMore.closest('.facets__group');
          if (!group) return;
          const expanded = group.classList.toggle('is-expanded');
          showMore.setAttribute('aria-expanded', expanded ? 'true' : 'false');
          const label = expanded ? showMore.dataset.labelLess : showMore.dataset.labelMore;
          if (label) showMore.textContent = label;
          return;
        }

        const density = target.closest('[data-density]');
        if (density) {
          this.applyDensity(density.dataset.density, true);
          return;
        }

        const preset = target.closest('[data-price-preset]');
        if (preset) {
          const panel = preset.closest('.facets__panel');
          if (!panel) return;
          const min = panel.querySelector('[data-price-min]');
          const max = panel.querySelector('[data-price-max]');
          if (min) min.value = preset.dataset.presetMin || '';
          if (max) max.value = preset.dataset.presetMax || '';
          this.apply();
          return;
        }

        const remover = target.closest('[data-active-facets] a, [data-facets-clear]');
        if (remover && remover.getAttribute('href')) {
          event.preventDefault();
          this.render(remover.getAttribute('href'), true);
        }
      }

      handleSubmit(event) {
        const form = event.target;
        if (!form || !form.matches || !form.matches('[data-facets-form]')) return;
        event.preventDefault();
        this.closeDrawer();
        this.apply();
      }

      /* ---------- Fetch flow ----------------------------------------- */

      applyDebounced() {
        window.clearTimeout(this.debounceTimer);
        this.debounceTimer = window.setTimeout(() => this.apply(), DEBOUNCE_MS);
      }

      buildUrl() {
        const form = this.form;
        const params = new URLSearchParams();
        if (form) {
          new FormData(form).forEach((value, key) => {
            if (typeof value !== 'string') return;
            if (value === '') return;
            if (key === 'page') return;
            /* re-added below from the select, which is the live control */
            if (key === 'sort_by') return;
            params.append(key, value);
          });
        }

        const select = this.querySelector('[data-sort-select]');
        let sort = '';
        if (select) {
          sort = select.value;
        } else if (form) {
          const hidden = form.querySelector('input[name="sort_by"]');
          if (hidden) sort = hidden.value;
        }
        if (sort) params.set('sort_by', sort);

        const query = params.toString();
        if (!query) return window.location.pathname;
        return window.location.pathname + '?' + query;
      }

      apply() {
        window.clearTimeout(this.debounceTimer);
        this.render(this.buildUrl(), true);
      }

      render(url, push) {
        const api = window.Heeman;
        if (!api || typeof api.fetchSection !== 'function' || !this.sectionId) {
          window.location.assign(url);
          return;
        }

        const token = ++this.requestId;
        const focused = this.focusKey();
        this.setLoading(true);

        api
          .fetchSection(this.sectionId, url)
          .then((fragment) => {
            if (token !== this.requestId) return;
            this.swap(fragment);
            if (push) window.history.pushState({}, '', url);
            this.setLoading(false);
            this.restoreFocus(focused);
          })
          .catch(() => {
            if (token !== this.requestId) return;
            this.setLoading(false);
            window.location.assign(url);
          });
      }

      setLoading(state) {
        const region = this.querySelector('[data-plp-results]');
        if (!region) return;
        region.classList.toggle('is-loading', state);
        if (state) {
          region.setAttribute('aria-busy', 'true');
        } else {
          region.removeAttribute('aria-busy');
        }
      }

      focusKey() {
        const active = document.activeElement;
        if (!active || !this.contains(active)) return null;
        return { name: active.getAttribute('name') || '', value: active.value || '' };
      }

      restoreFocus(key) {
        if (!key || !key.name) return;
        const escaped = key.name.replace(/["\\]/g, '\\$&');
        const candidates = this.querySelectorAll('[name="' + escaped + '"]');
        let match = null;
        candidates.forEach((el) => {
          if (match) return;
          if (el.value === key.value) match = el;
        });
        if (!match && candidates.length) match = candidates[0];
        if (!match) return;
        match.focus();
        if (match.type === 'number' && typeof match.setSelectionRange === 'function') {
          const end = String(match.value).length;
          try {
            match.setSelectionRange(end, end);
          } catch (error) {
            /* number inputs may refuse selection ranges */
          }
        }
      }

      swapHTML(fragment, selector) {
        const current = this.querySelector(selector);
        const next = fragment.querySelector(selector);
        if (!current || !next) return;
        current.innerHTML = next.innerHTML;
      }

      swap(fragment) {
        /* Fetched content must appear instantly: the shared reveal observer
           only handles the initial page load. */
        fragment.querySelectorAll('[data-reveal]').forEach((el) => el.removeAttribute('data-reveal'));
        fragment
          .querySelectorAll('[data-reveal-group]')
          .forEach((el) => el.removeAttribute('data-reveal-group'));

        this.swapHTML(fragment, '[data-plp-count]');
        this.swapHTML(fragment, '[data-chips-slot]');

        const currentToolbar = this.querySelector('[data-plp-toolbar]');
        const nextToolbar = fragment.querySelector('[data-plp-toolbar]');
        if (!currentToolbar !== !nextToolbar) {
          this.swapHTML(fragment, '[data-toolbar-slot]');
        } else if (currentToolbar && nextToolbar) {
          const currentCount = currentToolbar.querySelector('[data-results-count]');
          const nextCount = nextToolbar.querySelector('[data-results-count]');
          if (currentCount && nextCount) currentCount.textContent = nextCount.textContent;
          const currentBadge = currentToolbar.querySelector('[data-filter-count]');
          const nextBadge = nextToolbar.querySelector('[data-filter-count]');
          if (currentBadge && nextBadge) currentBadge.textContent = nextBadge.textContent;
        }

        this.swapHTML(fragment, '[data-plp-results]');

        const currentForm = this.form;
        const nextForm = fragment.querySelector('[data-facets-form]');
        if (currentForm && nextForm) {
          /* Filter order is stable, so open/closed groups are restored by
             position — a shopper working inside a group keeps it open. */
          const open = [];
          currentForm.querySelectorAll('[data-facets-group]').forEach((group) => open.push(group.open));
          currentForm.innerHTML = nextForm.innerHTML;
          const groups = currentForm.querySelectorAll('[data-facets-group]');
          if (groups.length === open.length) {
            groups.forEach((group, index) => {
              group.open = open[index];
            });
          } else {
            this.syncGroups(true);
          }
        }

        this.enhanceForm();
        this.applyDensity(this.columns || this.dataset.columns || '4', false);
      }
    }

    if (!customElements.get('heeman-facets')) {
      customElements.define('heeman-facets', HeemanFacets);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-accordion"] && !Shopify.designMode) return;
  try {
    
  /* Deep-link enhancement ONLY. Open/close is spec 02's <heeman-accordion>
     plus native <details> — nothing here touches it. */
  (() => {
    function openFromHash() {
      const id = window.location.hash.slice(1);
      if (!id) return;
      if (id.indexOf('faq-') !== 0) return;
      const target = document.getElementById(id);
      if (!target) return;
      if (target.tagName !== 'DETAILS') return;
      if (!target.closest('.faq-accordion')) return;
      target.classList.remove('is-closing');
      target.open = true;
      target.scrollIntoView({ block: 'start' });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', openFromHash);
    } else {
      openFromHash();
    }
    window.addEventListener('hashchange', openFromHash);
    document.addEventListener('shopify:section:load', openFromHash);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
  // Back-to-top control. Progressive enhancement over <a href="#">: with JS
  // off the anchor natively jumps to the top of the document.
  if (!customElements.get('heeman-back-to-top')) {
    customElements.define(
      'heeman-back-to-top',
      class HeemanBackToTop extends HTMLElement {
        connectedCallback() {
          if (this.hasAttribute('data-bound')) return;
          this.setAttribute('data-bound', '');
          this.addEventListener('click', this.handleClick.bind(this));
        }

        handleClick(event) {
          const trigger = event.target.closest('[data-back-to-top]');
          if (!trigger) return;
          event.preventDefault();
          window.scrollTo({ top: 0, behavior: this.scrollBehavior() });
        }

        // Honors both the OS reduced-motion setting and the theme's
        // animation kill switch (--motion, set by spec 01 / body.motion-reduced).
        scrollBehavior() {
          if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return 'auto';
          const motion = getComputedStyle(document.body).getPropertyValue('--motion').trim();
          if (motion === '0') return 'auto';
          return 'smooth';
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (() => {
    const WISHLIST_KEY = 'heeman:wishlist';

    /* ---- <heeman-cart-link> -------------------------------------------- */
    class HeemanCartLink extends HTMLElement {
      connectedCallback() {
        this.link = this.querySelector('a');
        this.bubble = this.querySelector('[data-cart-count]');
        if (!this.link) return;
        if (this.bound) return;
        this.bound = true;

        this.countTemplate = this.dataset.labelCount || '';

        this.onClick = (event) => {
          if (this.cartType() !== 'drawer') return;
          if (event.metaKey || event.ctrlKey || event.shiftKey) return;
          if (event.button && event.button !== 0) return;
          event.preventDefault();
          document.dispatchEvent(
            new CustomEvent('heeman:cart:open', { bubbles: true })
          );
        };
        this.onCartUpdated = (event) => {
          const cart = event.detail && event.detail.cart;
          if (!cart) return;
          this.render(cart.item_count);
        };

        this.link.addEventListener('click', this.onClick);
        document.addEventListener('heeman:cart:updated', this.onCartUpdated);
      }

      disconnectedCallback() {
        if (this.link && this.onClick) {
          this.link.removeEventListener('click', this.onClick);
        }
        if (this.onCartUpdated) {
          document.removeEventListener('heeman:cart:updated', this.onCartUpdated);
        }
        this.bound = false;
      }

      /* Live from <body data-cart-type> (spec 03) — never a stale attribute. */
      cartType() {
        if (window.Heeman && window.Heeman.cartType) return window.Heeman.cartType;
        if (document.body && document.body.dataset.cartType) {
          return document.body.dataset.cartType;
        }
        return 'drawer';
      }

      render(count) {
        const total = Number(count) || 0;
        if (this.bubble) {
          this.bubble.textContent = String(total);
          this.bubble.hidden = total === 0;
        }
        if (this.countTemplate) {
          this.link.setAttribute(
            'aria-label',
            this.countTemplate.replace('[n]', String(total))
          );
        }
      }
    }

    if (!customElements.get('heeman-cart-link')) {
      customElements.define('heeman-cart-link', HeemanCartLink);
    }

    /* ---- <heeman-wishlist-badge> --------------------------------------- */
    class HeemanWishlistBadge extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('button, a');
        this.bubble = this.querySelector('[data-wishlist-count]');
        if (!this.button) return;
        if (this.bound) return;
        this.bound = true;

        this.countTemplate = this.dataset.labelCount || '';

        this.onClick = () => {
          document.dispatchEvent(
            new CustomEvent('heeman:wishlist:open', { bubbles: true })
          );
        };
        this.onSync = () => this.render();
        this.onStorage = (event) => {
          if (event.key && event.key !== WISHLIST_KEY) return;
          this.render();
        };

        /* A real link navigates to the wishlist page; the destination-less
           button opens the wishlist drawer instead. */
        if (this.button.tagName === 'BUTTON') {
          this.button.addEventListener('click', this.onClick);
        }
        document.addEventListener('heeman:wishlist:updated', this.onSync);
        window.addEventListener('storage', this.onStorage);
        this.render();
      }

      disconnectedCallback() {
        if (this.button && this.onClick && this.button.tagName === 'BUTTON') {
          this.button.removeEventListener('click', this.onClick);
        }
        if (this.onSync) {
          document.removeEventListener('heeman:wishlist:updated', this.onSync);
        }
        if (this.onStorage) window.removeEventListener('storage', this.onStorage);
        this.bound = false;
      }

      /* Prefer spec 05's API; fall back to the same localStorage key. */
      count() {
        if (window.Heeman && window.Heeman.wishlist) {
          const handles = window.Heeman.wishlist.all();
          if (Array.isArray(handles)) return handles.length;
        }
        try {
          const raw = window.localStorage.getItem(WISHLIST_KEY);
          if (!raw) return 0;
          const parsed = JSON.parse(raw);
          if (!Array.isArray(parsed)) return 0;
          return parsed.length;
        } catch (error) {
          return 0;
        }
      }

      render() {
        const total = this.count();
        if (this.bubble) {
          this.bubble.textContent = String(total);
          this.bubble.hidden = total === 0;
        }
        if (this.countTemplate) {
          this.button.setAttribute(
            'aria-label',
            this.countTemplate.replace('[n]', String(total))
          );
        }
      }
    }

    if (!customElements.get('heeman-wishlist-badge')) {
      customElements.define('heeman-wishlist-badge', HeemanWishlistBadge);
    }

    /* ---- <heeman-nav-drawer> ------------------------------------------- */
    /* Open/close/Esc/backdrop/focus-return all belong to <heeman-dialog>
       (spec 02). This element only owns the header-specific lifecycle. */
    class HeemanNavDrawer extends HTMLElement {
      connectedCallback() {
        this.host = this.querySelector('heeman-dialog');
        if (!this.host) return;
        if (this.bound) return;
        this.bound = true;

        this.desktopQuery = window.matchMedia('(min-width: 990px)');
        this.onBreakpoint = (event) => {
          if (event.matches) this.hide();
        };
        this.onCartOpen = () => this.hide();

        if (this.desktopQuery.addEventListener) {
          this.desktopQuery.addEventListener('change', this.onBreakpoint);
        }
        document.addEventListener('heeman:cart:open', this.onCartOpen);
      }

      disconnectedCallback() {
        if (this.desktopQuery && this.desktopQuery.removeEventListener) {
          this.desktopQuery.removeEventListener('change', this.onBreakpoint);
        }
        if (this.onCartOpen) {
          document.removeEventListener('heeman:cart:open', this.onCartOpen);
        }
        this.bound = false;
      }

      hide() {
        if (this.host && typeof this.host.close === 'function') this.host.close();
      }
    }

    if (!customElements.get('heeman-nav-drawer')) {
      customElements.define('heeman-nav-drawer', HeemanNavDrawer);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('heeman-recommendations')) {
      return;
    }

    class HeemanRecommendations extends HTMLElement {
      connectedCallback() {
        if (this.dataset.loaded) {
          return;
        }
        this.observer = new IntersectionObserver(
          (entries) => {
            if (!entries.some((entry) => entry.isIntersecting)) {
              return;
            }
            this.observer.disconnect();
            this.load();
          },
          { rootMargin: '400px' }
        );
        this.observer.observe(this);
      }

      disconnectedCallback() {
        if (this.observer) {
          this.observer.disconnect();
        }
      }

      load() {
        if (!this.dataset.url || this.dataset.loaded) {
          return;
        }
        this.dataset.loaded = 'true';

        fetch(this.dataset.url)
          .then((response) => {
            if (!response.ok) {
              throw new Error(response.status);
            }
            return response.text();
          })
          .then((text) => {
            var doc = new DOMParser().parseFromString(text, 'text/html');
            var content = doc.querySelector('.recommendations');
            if (!content) {
              this.remove();
              return;
            }
            this.innerHTML = '';
            this.appendChild(content);
            if (window.Heeman && typeof window.Heeman.scanReveals === 'function') {
              window.Heeman.scanReveals(this);
            }
          })
          .catch(() => {
            this.remove();
          });
      }
    }

    customElements.define('heeman-recommendations', HeemanRecommendations);

    /* Theme editor: a re-rendered product section re-inserts the shell;
       connectedCallback re-arms the observer, so no extra work is needed.
       Re-init explicitly when THIS section is (re)loaded in the editor. */
    document.addEventListener('shopify:section:load', function (event) {
      var shell = event.target.querySelector('heeman-recommendations');
      if (shell) {
        delete shell.dataset.loaded;
        shell.connectedCallback();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (() => {
    /* ---- Sticky mobile add-to-cart bar -------------------------------- */
    if (!customElements.get('heeman-sticky-atc')) {
      class HeemanStickyAtc extends HTMLElement {
        connectedCallback() {
          this.button = this.querySelector('[data-sticky-add]');
          this.priceEl = this.querySelector('[data-sticky-price]');
          this.sectionId = this.dataset.sectionId;
          this.form = document.getElementById(this.dataset.formId);

          const section = document.getElementById('shopify-section-' + this.sectionId);
          this.sentinel = null;
          if (section) this.sentinel = section.querySelector('[data-atc-sentinel]');

          if (this.button) {
            this.button.addEventListener('click', () => {
              if (!this.form) return;
              if (typeof this.form.requestSubmit === 'function') {
                this.form.requestSubmit();
              } else {
                this.form.dispatchEvent(new Event('submit', { cancelable: true }));
              }
            });
          }

          if (this.sentinel) {
            this.observer = new IntersectionObserver(
              (entries) => {
                entries.forEach((entry) => {
                  /* Only once the buy buttons have scrolled UP out of view. */
                  const passed = !entry.isIntersecting && entry.boundingClientRect.top < 0;
                  this.setVisible(passed);
                });
              },
              { threshold: 0 }
            );
            this.observer.observe(this.sentinel);
          }

          this.onVariantChange = (event) => this.handleVariantChange(event);
          document.addEventListener('heeman:variant:change', this.onVariantChange);
        }

        disconnectedCallback() {
          if (this.observer) this.observer.disconnect();
          if (this.onVariantChange) {
            document.removeEventListener('heeman:variant:change', this.onVariantChange);
          }
        }

        setVisible(visible) {
          this.classList.toggle('is-visible', visible);
          if (visible) {
            this.removeAttribute('aria-hidden');
            this.removeAttribute('inert');
          } else {
            this.setAttribute('aria-hidden', 'true');
            this.setAttribute('inert', '');
          }
        }

        handleVariantChange(event) {
          const detail = event.detail || {};
          if (detail.sectionId !== this.sectionId) return;
          const variant = detail.variant;

          if (!variant) {
            if (this.button) {
              this.button.disabled = true;
              this.button.textContent = this.dataset.unavailableText;
            }
            return;
          }

          if (this.priceEl && window.Heeman && window.Heeman.formatMoney) {
            this.priceEl.textContent = window.Heeman.formatMoney(variant.price);
          }
          if (this.button) {
            this.button.disabled = !variant.available;
            if (variant.available) {
              this.button.textContent = this.dataset.addText;
            } else {
              this.button.textContent = this.dataset.soldOutText;
            }
          }
        }
      }

      customElements.define('heeman-sticky-atc', HeemanStickyAtc);
    }

    /* ---- Share button ------------------------------------------------- */
    if (!customElements.get('heeman-share-button')) {
      class HeemanShareButton extends HTMLElement {
        connectedCallback() {
          this.button = this.querySelector('button');
          if (!this.button) return;
          this.button.addEventListener('click', () => this.share());
        }

        async share() {
          const url = this.dataset.shareUrl || window.location.href;
          const title = this.dataset.shareTitle || document.title;

          if (navigator.share) {
            try {
              await navigator.share({ title: title, url: url });
              return;
            } catch (error) {
              return; /* dismissed by the shopper — nothing to report */
            }
          }

          try {
            await navigator.clipboard.writeText(url);
            this.toast(this.dataset.copiedText);
          } catch (error) {
            this.toast(this.dataset.copiedText);
          }
        }

        toast(message) {
          if (!message) return;
          document.dispatchEvent(
            new CustomEvent('heeman:toast', {
              detail: { message: message },
              bubbles: true
            })
          );
        }
      }

      customElements.define('heeman-share-button', HeemanShareButton);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search"]) return;
  try {
    
  (() => {
    /* Auto-submits the sort form on change. The "Apply" button in the same
       form is the no-JS path and stays keyboard reachable. */
    class HeemanSearchSort extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('form');
        this.select = this.querySelector('select');
        if (!this.form || !this.select) return;
        if (this.bound) return;
        this.bound = true;

        this.onChange = () => {
          if (typeof this.form.requestSubmit === 'function') {
            this.form.requestSubmit();
            return;
          }
          this.form.submit();
        };

        this.select.addEventListener('change', this.onChange);
      }

      disconnectedCallback() {
        if (this.select && this.onChange) {
          this.select.removeEventListener('change', this.onChange);
        }
        this.bound = false;
      }
    }

    if (!customElements.get('heeman-search-sort')) {
      customElements.define('heeman-search-sort', HeemanSearchSort);
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
